import { c as _c } from "react/compiler-runtime";
import Head from "next/head";
type LocationType = "city" | "state" | "village" | "area" | "category";
type VillaMetaProperties = {
  title: string;
  description: string;
  locationType: LocationType | string;
  locationTitle: string;
};
export const VillaMeta = t0 => {
  const $ = _c(17);
  const {
    title,
    description,
    locationType,
    locationTitle
  } = t0;
  const t1 = `اجاره ویلا ${locationTitle} | اجاره ویلای ${locationTitle} با بهترین قیمت در 4 قسط`;
  const t2 = `رزرو و اجاره ویلا‌ ${locationTitle} به صورت آنی و با بهترین قیمت مناسب جمع‌های خانوادگی و دوستانه. تنوع بیش از 1000 ویلای ${locationTitle} در اسنپ تریپ.`;
  let T0;
  let t3;
  let t4;
  let t5;
  if ($[0] !== description || $[1] !== locationTitle || $[2] !== locationType || $[3] !== t1 || $[4] !== t2 || $[5] !== title) {
    const defaultSchema = {
      title: t1,
      description: t2
    };
    const schema = {
      state: {
        title: `اجاره ویلا در ${locationTitle} | رزرو آنی ویلا و اقامتگاه با بهترین قیمت`,
        description: `اجاره ویلا در ${locationTitle} به صورت آنی | رزرو انواع ویلا، سوئیت و اقامتگاه با امکان انتخاب بر اساس ظرفیت، امکانات، منطقه و کنسلی بدون جریمه`
      },
      city: {
        title: `اجاره ویلا در ${locationTitle} | رزرو آنی ویلا و سوئیت با پرداخت قسطی`,
        description: `اجاره سوئیت و ویلا در ${locationTitle} به صورت آنلاین و در 4 قسط | انواع ویلا، سوئیت و اقامتگاه در ${locationTitle} با بهترین قیمت و پشتیبانی 24 ساعته`
      },
      village: {
        title: `اجاره ویلا و سوئیت در ${locationTitle} | اقامت در ${locationTitle} با بهترین قیمت`,
        description: `اجاره ویلا و سوئیت در ${locationTitle} با تضمین بهترین قیمت، امنیت، نظافت و تنوع اقامتگاه. رزرو آنی ویلا در ${locationTitle} با پشتیبانی 24 ساعته و لغو بدون جریمه`
      }
    };
    const getMeta = locationType_0 => schema[locationType_0] || defaultSchema;
    T0 = Head;
    t5 = <title>{title || getMeta(locationType as LocationType).title}</title>;
    t3 = "description";
    t4 = description || getMeta(locationType as LocationType).description;
    $[0] = description;
    $[1] = locationTitle;
    $[2] = locationType;
    $[3] = t1;
    $[4] = t2;
    $[5] = title;
    $[6] = T0;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = <meta name={t3} content={t4} />;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T0 || $[14] !== t5 || $[15] !== t6) {
    t7 = <T0>{t5}{t6}</T0>;
    $[13] = T0;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};